<template>
<div :class="['wrapper', classes]">
  <header class="main-header">

    <!-- <span class="logo-mini">
      <a href="/"><img src="/static/img/jaiswal.png" id="logo" alt="Logo" class="img-responsive center-block logo"></a>
    </span> -->
    <!-- Header Navbar -->
    <nav class="navbar navbar-static-top" role="navigation">
      <!-- Sidebar toggle button-->
      <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>
      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">

          <!-- User Account Menu -->
          <li class="dropdown user user-menu" v-on:click="Logout()">
            <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
              <span class="hidden-xs">Log Out</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </header>
  <!-- Left side column. contains the logo and sidebar -->
  <sidebar :display-name="demo.displayName" :picture-url="demo.avatar" />

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        {{$route.name.toUpperCase() }}
        <small>{{ $route.meta.description }}</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;">
            <i class="fa fa-home"></i></a>
        </li>
        <li class="active">{{$route.name.toUpperCase()}}</li>
      </ol>
    </section>

    <router-view></router-view>
  </div>

  <!-- /.content-wrapper -->

  <!-- Main Footer -->
  <footer class="main-footer">
    <!-- <strong>Copyright &copy; {{year}}
      <a href="javascript:;">CoPilot</a>.</strong> All rights reserved. -->
  </footer>
</div>
<!-- ./wrapper -->
</template>

<script>
import faker from 'faker'
import {
  mapState
} from 'vuex'
import config from '../config'
import Sidebar from './Sidebar'
import 'hideseek'

export default {
  name: 'Dash',
  components: {
    Sidebar
  },
  data: function() {
    return {
      // section: 'Dash',
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      },
      error: ''
    }
  },
  mounted: function() {
    // this.CheckLogin();
  },
  computed: {
    ...mapState([
      'userInfo'
    ]),
    demo() {
      return {
        displayName: faker.name.findName(),
        avatar: faker.image.avatar(),
        email: faker.internet.email(),
        randomCard: faker.helpers.createCard()
      }
    }
  },
  methods: {
    CheckLogin() {
      if(localStorage.getItem('user')){
        console.log(localStorage.getItem('user'));
      }
      else{
        console.log("admin object not set")
        this.$router.push('/login')
      }
    },
    Logout() {
      console.log("Log Out Clicked")
      localStorage.removeItem("user")
      localStorage.removeItem("token")
      this.$router.push('/login')
      location.reload();
    },
    GetFeedbacks() {
      console.log("Get All Feedbacks API Called...");
    }
  }
}
</script>

<style>
.wrapper.fixed_layout .main-header {
  position: fixed;
  width: 100%;
}

.wrapper.fixed_layout .content-wrapper {
  padding-top: 50px;
}

.wrapper.fixed_layout .main-sidebar {
  position: fixed;
  height: 100vh;
}

@media (max-width: 767px) {
  .wrapper.hide_logo .main-header .logo {
    display: none;
  }
}

.logo-mini,
.logo-lg {
  text-align: left;
}

.logo-mini img,
.logo-lg img {
  padding: 0.4em !important;
}

.logo-lg img {
  display: -webkit-inline-box;
  width: 25%;
}

.user-panel {
  height: 4em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}
</style>



// WEBPACK FOOTER //
// Dash.vue?9aa2d3e8